import React from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { LoadingCard } from './LoadingCard';

interface Props {
    minHeight?: number;
}

export const LoadingGridAnimation = ({ minHeight }: Props) => {
    const loadingCards = Array(6).fill(<LoadingCard minHeight={minHeight} />);

    return (
        <AnimatePresence>
            {loadingCards.map((card, index) => (
                <motion.div
                    key={`loading-card-${index}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ delay: index * 0.75, duration: 0.75 }}
                >
                    {card}
                </motion.div>
            ))}
        </AnimatePresence>
    );
};
